import { useMMKVString } from 'react-native-mmkv';

import { storage, storageKeys } from '@/constants/storage';
import { useShouldShowReferralBanner } from '@/hooks/customer/useShouldShowReferralBanner';

import { ReferralBanner } from './ReferralBanner';
import type { ReferralBannerSectionProps } from './types';

const ReferralBannerSection = ({
  shop,
  testID,
}: ReferralBannerSectionProps) => {
  const [signedInCustomerId] = useMMKVString(storageKeys.customerId, storage);
  const showBanner = useShouldShowReferralBanner({
    shop,
    customerId: signedInCustomerId,
  });

  if (!showBanner || !signedInCustomerId || !shop) return null;

  return (
    <ReferralBanner
      shopId={shop.id}
      customerId={signedInCustomerId}
      testID={testID}
    />
  );
};

ReferralBannerSection.displayName = 'ReferralBannerSection';
export { ReferralBannerSection };
